import { useAppContext } from '@/context/AppContext';
import { GroupSelector } from './GroupSelector';
import { SaveButtons } from './SaveButtons';
import { SearchBar } from './SearchBar';
import { useCallback } from 'react';

export function Toolbar() {
  const { state, dispatch } = useAppContext();

  const handleSearchChange = useCallback((query: string) => {
    dispatch({ type: 'SET_SEARCH_QUERY', payload: query });
  }, [dispatch]);

  const handleCollapseAll = useCallback(() => {
    dispatch({ type: 'TRIGGER_COLLAPSE_ALL' });
  }, [dispatch]);

  const handleExpandAll = useCallback(() => {
    dispatch({ type: 'TRIGGER_EXPAND_ALL' });
  }, [dispatch]);

  const handleToggleAll = useCallback(() => {
    if (state.ui.collapseAllMode) {
      handleExpandAll();
    } else {
      handleCollapseAll();
    }
  }, [state.ui.collapseAllMode, handleCollapseAll, handleExpandAll]);

  return (
    <div className="top-bar">
      <div className="top-bar-inner">
        <button
          onClick={handleToggleAll}
          className="collapse-all-btn"
          title={state.ui.collapseAllMode ? "Expand all groups" : "Collapse all groups"}
        >
          {state.ui.collapseAllMode ? "Expand All" : "Collapse All"}
        </button>
        <div className="top-bar-left">
          {state.xmlDoc && <GroupSelector />}
        </div>
        {state.xmlDoc && (
          <>
            <div className="top-bar-center">
              <SearchBar onSearchChange={handleSearchChange} />
            </div>
            <div className="top-bar-right">
              <SaveButtons />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
